var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "text-align": "center" } }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("BetSlip.addSelection.dialog.title")))]),
    _vm._v(" "),
    _c("div", { staticClass: "dialog_text" }, [
      _c("p", { key: _vm.dialogBetslipMsg.data[0] }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.$t(
                "BetSlip.addSelection.error." + _vm.dialogBetslipMsg.data[0],
                { n: _vm.dialogBetslipMsg.data[1] }
              )
            ) +
            "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "v-btn primary",
        staticStyle: { "margin-left": "0px" },
        on: {
          click: function($event) {
            return _vm.closeDialog()
          }
        }
      },
      [
        _c("span", [
          _vm._v(_vm._s(_vm.$t("BetSlip.addSelection.dialog.btn.OK")))
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a15747c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a15747c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/betslipMsg.vue
// module id = null
// module chunks = 